import { type ObjectValuesUnionType } from '../utils/typing';

// Display mode
export const MultiviewDisplayModes = Object.freeze({
  NORMAL: 0,
  EXPANDED: 1,
});

export type MultiviewDisplayMode = ObjectValuesUnionType<typeof MultiviewDisplayModes>;
